import styles from '../index.module.scss';
import { defineComponent, h } from 'vue';
// @ts-ignore
import circle_tilt_svg from '../circle_tilt.inline.svg';
import { FormWithLabels, Label } from '@components/form';
import AngleInput from '@frontend/components/AngleInput';
import VectorEditor from '@frontend/components/VectorEditor';
import { fromAngles } from '@frontend/vector3';
import { Vector3 } from 'three';
import { round } from '@frontend/maths';

export const TiltEditor = defineComponent({
    props: {
        theta: { required: true, type: Number },
        phi: { required: true, type: Number },
    },

    emits: {
        'update:phi': (x: number) => true,
        'update:theta': (x: number) => true,
    },

    computed: {
        tilt() {
            const vector = fromAngles(this.theta * Math.PI/180, this.phi * Math.PI/180);
            return new Vector3(
                round(vector.x, 5),
                round(vector.y, 5),
                round(vector.z, 5),
            );
        },
    },

    render() {
        return [
            h('div', { class: styles.svg, innerHTML: circle_tilt_svg }),

            h(FormWithLabels, { class: 'mt-3', gap: 'tight', width: '3rem' }, () => [
                h(Label, null, {
                    label: () => h('span', 'Theta'),
                    input: () => h(AngleInput, {
                        min: 0,
                        max: 360,
                        value: this.theta,
                        'onUpdate:value': x => this.$emit('update:theta', x),
                        angles: [0, 45, 90, 135, 180],
                    }),
                }),

                h(Label, null, {
                    label: () => h('span', 'Phi'),
                    input: () => h(AngleInput, {
                        min: 0,
                        max: 360,
                        value: this.phi,
                        'onUpdate:value': x => this.$emit('update:phi', x),
                        angles: [0, 90, 180, 270, 360],
                    }),
                }),

                h(Label, null, {
                    label: () => h('span', 'Vector'),
                    input: () => h(VectorEditor, { value: this.tilt, readonly: true }),
                }),
            ]),
        ];
    },
});
